import { render, staticRenderFns } from "./TipoEventos.vue?vue&type=template&id=94bfb244&scoped=true&"
import script from "./TipoEventos.vue?vue&type=script&lang=js&"
export * from "./TipoEventos.vue?vue&type=script&lang=js&"
import style0 from "./TipoEventos.vue?vue&type=style&index=0&id=94bfb244&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94bfb244",
  null
  
)

export default component.exports